import Vue from 'vue';
import bus from './bus.js';
import http from './http';
import httpAxios from './httpAxios';
// import api from './api';
import storage from './storage';
import store from '../store';
// import toast from './toast';
import dayJs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';
// import wxbug from './wxbug';
import _ from './lodash';
import indexedDB from '../utils/indexdbcs';
dayJs.extend(relativeTime);
dayJs.locale('zh-cn');

window.$bus = Vue.prototype.$bus = bus;
window.$http = Vue.prototype.$http = http;
window.$httpAxios = Vue.prototype.$httpAxios = httpAxios;
// window.$api = Vue.prototype.$api = api;
window.$storage = Vue.prototype.$storage = storage;
// window.$toast = Vue.prototype.$toast = toast;
window.$store = Vue.prototype.$store = store;
// window.$wxbug = Vue.prototype.$wxbug = wxbug;
window._ = Vue.prototype._ = _;
window.moment = Vue.prototype.moment = dayJs;
window.$indexedDB = Vue.prototype.$indexedDB = indexedDB;

// import { Confirm, Alert } from 'vue-ydui/dist/lib.rem/dialog';
// Vue.prototype.$confirm = Confirm;
// Vue.prototype.$alert = Alert;

